import { render, staticRenderFns } from "./MainError.vue?vue&type=template&id=56988fb2&scoped=true&"
import script from "./MainError.vue?vue&type=script&lang=ts&"
export * from "./MainError.vue?vue&type=script&lang=ts&"
import style0 from "./MainError.vue?vue&type=style&index=0&id=56988fb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56988fb2",
  null
  
)

export default component.exports